import React from 'react'
import { CircularProgress, Paper, Typography } from '@material-ui/core'
import { useTranslation } from '@/langs/useTranslation'
import { ImageUploader, TextInput } from './Compo'

const PlatformTab = ({ value, onChange, loading }) => {
  const { t } = useTranslation()

  return (
    <Paper elevation={0} style={{ backgroundColor: "#F8F9FC", borderRadius: "10px", marginTop: 24 }}>
      <Typography variant="h5" style={{marginBottom: 24}}>
        1. {t({ defaultMessage: "编辑 Platform 页签" })}
        {loading && <CircularProgress size={22} style={{marginLeft: 16}} />}
      </Typography>
      <ImageUploader
        number="1.1"
        title={t({defaultMessage: "图标上传"})}
        value={value.icon}
        name="platformTab.icon"
        onChange={onChange}
        disbale={loading}
      />
      <TextInput
        number="1.2"
        title={t({defaultMessage: "文本上传"})}
        value={value.text}
        name="platformTab.text"
        placeholder={t({defaultMessage: "例：Platform"})}
        onChange={onChange}
        disabled={loading}
      />
    </Paper>
  )
}

export default PlatformTab